var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 172,
    viewBox: "0 0 98 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2085662677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2085662676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.178 69.9651L16.7773 85.9961L33.178 102.034",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.6528 69.9651L81.0607 85.9961L64.6528 102.034",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.5006 61.1597L38.5269 110.84",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M96.8311 131.763V162.832C96.8311 167.34 93.1712 171 88.6634 171H9.16771C4.65989 171 1 167.34 1 162.832V9.16771C1 4.65989 4.65989 1 9.16771 1C9.16771 1 89.8592 1.06523 90.4317 1.18843C94.0916 1.99288 96.8383 5.26141 96.8383 9.16771V131.763H96.8311Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6475 1.83325L72.0456 12.2839C71.1904 14.7552 68.864 16.4148 66.255 16.4148H31.5839C28.9676 16.4148 26.6412 14.7552 25.7933 12.2839L22.1914 1.83325",
    fill: "#33D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6475 1.83325L72.0456 12.2839C71.1904 14.7552 68.864 16.4148 66.255 16.4148H31.5839C28.9676 16.4148 26.6412 14.7552 25.7933 12.2839L22.1914 1.83325",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.749 159.418H73.0813",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f0e16451e04ddde7538800b3432e43c8.svg";
export { ForwardRef as ReactComponent };